var QueueWaitOfferThresholdsBuilder = /** @class */ (function () {
    function QueueWaitOfferThresholdsBuilder() {
        this.queueWaitOfferThresholds = {
            enableOfferPerCalls: false,
            enableOfferPerMinutes: false,
            enableOfferPerAudioIterations: false,
            maxWaitingCallsThreshold: 0,
            maxMinutesWaitThreshold: 0,
            maxAudioIterationsThreshold: 0
        };
    }
    QueueWaitOfferThresholdsBuilder.prototype.withEnableOfferPerMinutes = function (enableOfferPerMinutes) {
        this.queueWaitOfferThresholds.enableOfferPerMinutes = enableOfferPerMinutes;
        return this;
    };
    QueueWaitOfferThresholdsBuilder.prototype.withEnableOfferPerAudioIterations = function (enableOfferPerAudioIterations) {
        this.queueWaitOfferThresholds.enableOfferPerAudioIterations = enableOfferPerAudioIterations;
        return this;
    };
    QueueWaitOfferThresholdsBuilder.prototype.withEnableOfferPerCalls = function (enableOfferPerCalls) {
        this.queueWaitOfferThresholds.enableOfferPerCalls = enableOfferPerCalls;
        return this;
    };
    QueueWaitOfferThresholdsBuilder.prototype.withMaxWaitingCallsThreshold = function (maxWaitingCallsThreshold) {
        this.queueWaitOfferThresholds.maxWaitingCallsThreshold = maxWaitingCallsThreshold;
        return this;
    };
    QueueWaitOfferThresholdsBuilder.prototype.withMaxMinutesWaitThreshold = function (maxMinutesWaitThreshold) {
        this.queueWaitOfferThresholds.maxMinutesWaitThreshold = maxMinutesWaitThreshold;
        return this;
    };
    QueueWaitOfferThresholdsBuilder.prototype.withMaxAudioIterationsThreshold = function (maxAudioIterationsThreshold) {
        this.queueWaitOfferThresholds.maxAudioIterationsThreshold = maxAudioIterationsThreshold;
        return this;
    };
    QueueWaitOfferThresholdsBuilder.prototype.build = function () {
        return this.queueWaitOfferThresholds;
    };
    return QueueWaitOfferThresholdsBuilder;
}());
export { QueueWaitOfferThresholdsBuilder };
//# sourceMappingURL=queue-wait-offer-thresholds.builder.js.map